/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useEffect, useState, useCallback, memo } from 'react';
import UILink from 'UIComponents/link/UILink';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getResult, getHasTranscript, getTranscriptReady, getCRMObjectId } from '../call-message/operators/callMessageGetters';
import CallMessagePropType from '../operators/CallMessagePropType';
import { Flex, FlexShrink, Small } from './StyledComponents';
import AsyncCallTranscriptsUI from './AsyncCallTranscriptsUI';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CallTranscript({
  callMessage
}) {
  const [isTranscriptOpen, setIsTranscriptOpen] = useState(false);
  const engagementId = getCRMObjectId(callMessage);
  const hasTranscript = getHasTranscript(callMessage);
  const transcriptReady = getTranscriptReady(callMessage);
  const hasTranscriptResult = hasTranscript && getResult(hasTranscript);
  const isTranscriptReady = transcriptReady && getResult(transcriptReady);
  const handleOpenTranscript = useCallback(() => {
    setIsTranscriptOpen(true);
  }, []);
  const handleCloseTranscript = useCallback(() => {
    setIsTranscriptOpen(false);
  }, []);
  useEffect(() => {
    if (hasTranscriptResult && isTranscriptReady) {
      AsyncCallTranscriptsUI.preload();
    }
  }, [hasTranscriptResult, isTranscriptReady]);
  if (!hasTranscriptResult) {
    return null;
  }
  if (!isTranscriptReady) {
    return /*#__PURE__*/_jsx(FlexShrink, {
      children: /*#__PURE__*/_jsxs(Flex, {
        children: [/*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(UILoadingSpinner, {
            size: "extra-small"
          })
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(Small, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "conversations-calling-message.timeline-call-metadata.call-transcription.loading"
            })
          })
        })]
      })
    });
  }
  return /*#__PURE__*/_jsxs(FlexShrink, {
    className: "m-left-3",
    "data-test-id": "call-transcript",
    children: [/*#__PURE__*/_jsx(UILink, {
      onClick: handleOpenTranscript,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-calling-message.timeline-call-metadata.call-transcription.title"
      })
    }), isTranscriptOpen && /*#__PURE__*/_jsx(AsyncCallTranscriptsUI, {
      onCloseSidebar: handleCloseTranscript,
      engagementId: engagementId
    })]
  });
}
CallTranscript.propTypes = {
  callMessage: CallMessagePropType.isRequired
};
export default /*#__PURE__*/memo(CallTranscript);